import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { environment } from '../../../../environments/environment';
import { WarehouseMovementImportSuccessBuilder } from '../../models/builders/warehouse-movement-import-succes.builder';
import { WarehouseMovementBuilder } from '../../models/builders/warehouse-movement.builder';

const importMovementBody = (data: {id: number}) => ({
  id: data.id
});

const importMovementsBody = (movements: {id: number}[]) => ({
  movements: movements.map(d => importMovementBody(d))
});

@Injectable()
export class WarehouseMovementsApiService {

  private apiUrl: string;

  constructor(private httpClient: HttpClient) {
    this.apiUrl = `${environment.apiUrl}warehouse-movements`;
  }

  getWarehouseMovements(quantity: number) {
    const params = new HttpParams().append('quantity', quantity.toString());

    return this.httpClient.get(this.apiUrl, { params }).pipe(
      map(WarehouseMovementBuilder.fromList)
    );
  }

  getWarehouseMovementsToImport() {
    return this.httpClient.get(`${this.apiUrl}/to-import`).pipe(
      map(WarehouseMovementBuilder.fromList)
    );
  }

  getWarehouseMovementByHash(hash: string) {
    return this.httpClient.get(`${this.apiUrl}/${hash}`)
      .pipe(
        map(WarehouseMovementBuilder.fromJson)
      );
  }

  searchWarehouseMovements(filterValue: string) {
    let params = new HttpParams();
    if (filterValue !== null && filterValue !== undefined) {
      params = new HttpParams().append('search', filterValue.toString());
    }

    return this.httpClient.get(`${this.apiUrl}/search`, { params }).pipe(
      map(WarehouseMovementBuilder.fromList)
    );
  }

  importMovements(movements: { id: number }[]) {
    return this.httpClient.post(`${this.apiUrl}/imports`, importMovementsBody(movements)).pipe(
      map(WarehouseMovementImportSuccessBuilder.fromJson)
    );
  }

}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/services/api/warehouse-movements-api.service.ts